import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class RouteInterceptorService {
    private routeHistory: {url: string, fragment: string, queryParams: {}}[] = [];

    private isBackUsed: boolean;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
    ) {
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(() => {
                this.setURLs();
            });
    }

    private setURLs(): void {
        if (!this.isBackUsed) {
            const queryParams = this.route.snapshot.queryParams;
            const fragment = this.route.snapshot.fragment;
            const url = window.location.pathname;

            this.routeHistory.push({
                url,
                fragment,
                queryParams,
            });
        } else {
            this.isBackUsed = false;
        }
    }

    public goBackInRouteHistory() {
        this.routeHistory.pop();
        this.isBackUsed = true;
        return this.routeHistory[this.routeHistory.length - 1] || { url: '', fragment: null, queryParams: {}};
    }
}
